import { render } from "./loadingWrapper.vue?vue&type=template&id=7c9db0c8&scoped=true&ts=true"
import script from "./loadingWrapper.vue?vue&type=script&lang=ts"
export * from "./loadingWrapper.vue?vue&type=script&lang=ts"

import "./loadingWrapper.vue?vue&type=style&index=0&id=7c9db0c8&lang=scss&scoped=true"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9db0c8"]])

export default __exports__